module.exports = __webpack_public_path__ + "img/box_bg4.6bfc509.png";